import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Avatar,
  Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BOOKINGS } from '../../component/common/Routes/AppRoutes';
import '../../styles/SuccessPage.css';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';

const EditBookingSuccessPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const bookingType = location?.state?.BookingType;
  const getBookingsRoute = () => {
    switch (user.role) {
      case 'Admin':
      case 'Staff':
        return BOOKINGS;
      case 'Vendor':
        return '/vendor/bookings';
      case 'Customer':
        return '/customer/bookings';
      default:
        return BOOKINGS;
    }
  };

  useEffect(() => {
    dispatch(resetBookingDetails());
  }, [dispatch]);

  return (
    <Box className='success-page'>
      <Container maxWidth='md'>
        <Paper elevation={4} className='success-container fade-in'>
          <Avatar className='success-icon'>
            <CheckCircleIcon sx={{ fontSize: 50, color: 'green' }} />
          </Avatar>

          <Typography variant='h4' className='success-title slide-down'>
            Booking Updated Successfully
          </Typography>

          <Typography
            variant='h6'
            className='success-message slide-down slide-delay-1'
          >
            {bookingType
              ? `Customer booking details have been modified as requested After Payment.
                    (Check Customer Registered Mail  For Payment)
              `
              : `     Customer booking details have been modified as requested`}
          </Typography>

          <Box className='success-button-container slide-down slide-delay-3'>
            <Button
              variant='contained'
              color='primary'
              className='view-booking-btn'
              onClick={() => navigate(getBookingsRoute())}
            >
              View My Bookings
            </Button>
            <Button
              variant='outlined'
              color='secondary'
              className='return-home-btn'
              onClick={() => navigate('/')}
            >
              Return Home
            </Button>
          </Box>

          {/* Decorative Elements */}
          <Box className='decorative-container'>
            <Box className='decorative-circle-green success-icon' />
            <Box className='decorative-circle-blue success-icon' />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default EditBookingSuccessPage;
